import { useState, useEffect, useContext } from 'react';
import { useFragment, graphql } from 'react-relay';
import PropTypes from 'prop-types';

// components
import FavoritesItemProvider from 'dibs-portfolio-folder/exports/FavoritesItemProvider';
import { addForceFavoriteRefetchHandler } from 'dibs-buyer-layout/exports/loginHandlers';

import { FavoritesItem } from '../../components/global/FavoriteIcons/FavoritesItem';
import { FavoritesProvider } from '../../components/global/FavoriteIcons/FavoritesProvider';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

// helpers
import { locations } from '../../utils/tracking/shared/favoritesTracking';
import {
    isSaveIconUpdateAbTestVariant,
    trackSaveIconUpdateAbTest,
} from '../helpers/saveIconUpdateAbTestHelpers';

import styles from './PdpSharedSidebarFavorites.scss';

export function PdpSharedSidebarFavorites(props) {
    // Todo: Directly pass in userId
    const { isClient, environment, userId, item: itemRef, showAuctionsTooltip } = props;

    const item = useFragment(
        graphql`
            fragment PdpSharedSidebarFavorites_item on Item {
                ...FavoritesItem_item
                ...FavoritesItemProvider_item
                serviceId
                isAuctionEnabled
            }
        `,
        itemRef
    );
    const [shouldFavoritesProviderRefetch, setShouldFavoritesProviderRefetch] = useState(false);
    const { isMobile } = useContext(ServerVarsContext);

    const isSaveIconUpdateVariant = isClient && isSaveIconUpdateAbTestVariant();
    const applyMouseEvents = !isMobile && isSaveIconUpdateVariant;
    const iconClass = isSaveIconUpdateVariant ? styles.icon : undefined;
    const favoritesItemProviderClass = applyMouseEvents ? styles.favoritesItemProvider : undefined;

    useEffect(() => {
        addForceFavoriteRefetchHandler(() => {
            setShouldFavoritesProviderRefetch(true);
        });
    }, [setShouldFavoritesProviderRefetch]);

    useEffect(() => {
        trackSaveIconUpdateAbTest();
    }, []);

    return (
        <FavoritesProvider
            environment={environment}
            location={item?.isAuctionEnabled ? locations.AUCTION_PDP : locations.SIDEBAR}
            disable={!isClient}
            userId={userId}
            itemIds={[item?.serviceId]}
            shouldAutoFavorite
            shouldRefetch={shouldFavoritesProviderRefetch}
        >
            {
                // eslint-disable-next-line
                ({ props: renderProps }) => (
                    <FavoritesItemProvider
                        item={item}
                        user={null}
                        applyMouseEvents={applyMouseEvents}
                        showFolderWhenFavorited={isSaveIconUpdateVariant}
                        className={favoritesItemProviderClass}
                    >
                        {({ isFolderVisible, showFolderPlusIcon, setHeartFilledStatus }) => (
                            <FavoritesItem
                                {...renderProps}
                                fetchFolder={renderProps?.fetchFolder && isFolderVisible}
                                item={item}
                                itemImage={props.itemImage}
                                wrapperClass={props.wrapperClass}
                                heartIconWrapperClass={props.heartIconWrapperClass}
                                folderIconWrapperClass={props.folderIconWrapperClass}
                                showAuctionsTooltip={showAuctionsTooltip}
                                showFolderPlusIcon={showFolderPlusIcon}
                                setHeartFilledStatus={setHeartFilledStatus}
                                heartIconClass={iconClass}
                                folderIconClass={iconClass}
                            />
                        )}
                    </FavoritesItemProvider>
                )
            }
        </FavoritesProvider>
    );
}

PdpSharedSidebarFavorites.propTypes = {
    userId: PropTypes.string,
    isClient: PropTypes.bool.isRequired,
    wrapperClass: PropTypes.string,
    heartIconWrapperClass: PropTypes.string,
    folderIconWrapperClass: PropTypes.string,
    environment: PropTypes.object.isRequired,
    itemImage: PropTypes.string,
    item: PropTypes.object.isRequired,
    showAuctionsTooltip: PropTypes.bool,
};
